import { renderLogoImg } from "@components/layout/header/Logo";
import {
  faArrowDownLeftAndArrowUpRightToCenter,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faInfoCircle,
  faWindowRestore,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocalStorage, useWindowDimensions } from "@hooks";
import { Tooltip } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import scribenoteIcon from "../../assets/imgs/Logo_icon.png";

export const MaximizedPipControls = () => {
  const closePip = () => window.postMessage({ returnToTab: true });
  const minimize = () =>
    window.top!.resizeTo(window.top!.outerWidth, 1);

  return (
    <div className="flex flex-row justify-end items-center p-2 pr-0 gap-2">
      <Tooltip arrow title="Return to Scribenote">
        <button
          className="hover:opacity-50"
          onClick={closePip}
          data-mx-label="pip-close"
        >
          <FontAwesomeIcon
            icon={faWindowRestore}
            size="lg"
            className="text-brand"
          />
        </button>
      </Tooltip>

      <Tooltip arrow title="Minimize Widget">
        <button
          className="hover:opacity-50"
          onClick={minimize}
          data-mx-label="pip-minimize"
        >
          <FontAwesomeIcon
            icon={faArrowDownLeftAndArrowUpRightToCenter}
            size="lg"
            className="text-brand"
          />
        </button>
      </Tooltip>
    </div>
  );
};

export const MinimizedPipOverlay = () => {
  const location = useLocation();
  const { outer } = useWindowDimensions(window.top!);
  const [restoredHeight, setRestoredHeight] = useLocalStorage(
    "pip-size",
    -1,
  );

  const maximize = () => {
    window.top!.resizeTo(
      window.top!.outerWidth,
      Math.max(250, restoredHeight),
    );
  };

  useEffect(() => {
    if (outer.height > 400) {
      setRestoredHeight(outer.height);
    }
  }, [outer, setRestoredHeight]);

  function closePip() {
    window.postMessage({ returnToTab: true });
  }

  if (!location.pathname.includes("/pip")) return null;

  return (
    <div className="fixed inset-0 z-99999 [@media(min-height:100px)]:hidden">
      <div className="bg-primary h-full flex flex-row items-center p-5 gap-2">
        <div
          className="self-center flex-1 flex flex-row items-center shrink-0 pr-2 gap-2"
          onClick={maximize}
        >
          <div className="w-[150px] cursor-pointer self-center mb-2 [@media(max-width:350px)]:hidden">
            {renderLogoImg(true)}
          </div>
          <div className="cursor-pointer self-center [@media(min-width:350px)]:hidden">
            <img src={scribenoteIcon} className="w-[40px]" />
          </div>
          <Tooltip
            arrow
            placement="bottom"
            title="Widget Mode allows you to access Scribenote features more easily side-by-side with your PIMS/medical records. Click to learn more"
          >
            <a
              className="text-xs text-nowrap bg-cyan-500 text-white hover:text-white focus:text-white hover:no-underline focus:no-underline px-2 py-1 rounded-full font-medium"
              href="https://docs.scribenote.com/en/articles/12602342-how-to-use-widget-mode"
              target="_blank"
              rel="noreferrer"
            >
              Widget Mode <FontAwesomeIcon icon={faInfoCircle} />
            </a>
          </Tooltip>
        </div>

        <Tooltip arrow title="Return to Scribenote">
          <button
            className="hover:opacity-50"
            onClick={closePip}
            data-mx-label="pip-close"
          >
            <FontAwesomeIcon
              icon={faWindowRestore}
              size="lg"
              className="text-brand"
            />
          </button>
        </Tooltip>

        <Tooltip
          arrow
          title="Expand Widget"
          data-mx-label="pip-expand"
        >
          <button className="hover:opacity-50" onClick={maximize}>
            <FontAwesomeIcon
              icon={faArrowUpRightAndArrowDownLeftFromCenter}
              size="lg"
              className="text-brand"
            />
          </button>
        </Tooltip>
      </div>
    </div>
  );
};
